import React, { useState } from "react";
import styles from "./styles.module.scss";
import { PlusIcon, MinusIcon } from "../Icons";

type QA = { q: string; a: React.ReactNode };

const brandLink = (href: string, label: string) => (
  <a href={href} target="_blank" rel="noreferrer">
    {label}
  </a>
);

const FAQ: QA[] = [
  {
    q: "Como funciona o programa de afiliados?",
    a: "O Parceiros Promo é uma plataforma de afiliados voltada para produtos e serviços de viagem. Ao se cadastrar, você recebe links exclusivos para divulgar as marcas parceiras e ganha comissão por cada venda realizada através deles. Além disso, a plataforma oferece acompanhamento de resultados, materiais de divulgação e suporte para ajudar você a potencializar seus ganhos.",
  },
  {
    q: "O que preciso para me tornar afiliado?",
    a: "Para se tornar um afiliado Parceiros Promo, basta realizar seu cadastro na plataforma e aguardar a aprovação da equipe responsável. É importante possuir canais de divulgação ativos, como redes sociais, blog, site, comunidade ou outras formas de comunicação com o público.",
  },
  {
    q: "Quais marcas posso divulgar?",
    a: (
      <>
        Os afiliados podem divulgar todas as marcas parceiras cadastradas no
        nosso programa:{" "}
        {brandLink("https://www.segurospromo.com.br/", "Seguros Promo")},{" "}
        {brandLink("https://www.vaidepromo.com.br/", "Vai de Promo")},{" "}
        {brandLink("https://travelbds.com/", "Travel BDS")},{" "}
        {brandLink("https://fluencypass.com/", "Fluency Pass")} e{" "}
        {brandLink("https://getmalas.com.br/", "GetMalas")}.
      </>
    ),
  },
  {
    q: "Como e quando recebo minha comissão?",
    a: "As comissões são fechadas no último dia de cada mês e os pagamentos são realizados no dia 23 do mês seguinte, desde que o afiliado tenha atingido o valor mínimo determinado por cada marca. O pagamento é feito mediante emissão de nota fiscal e envio pela plataforma. Todas as informações de vendas e comissões podem ser acompanhadas diretamente no painel do afiliado.",
  },
  {
    q: "Como vocês sabem que a venda é do afiliado?",
    a: "Cada afiliado recebe links exclusivos e rastreáveis. Quando um cliente realiza uma compra através desse link, a venda é automaticamente atribuída ao afiliado responsável, garantindo o registro correto da comissão.",
  },
  {
    q: "Tenho cupons personalizados para divulgar?",
    a: "Sim. Algumas campanhas e marcas disponibilizam cupons personalizados e exclusivos para afiliados, ajudando a aumentar a conversão das vendas e oferecer benefícios aos clientes.",
  },
  {
    q: "O que posso fazer para não ter meu cadastro reprovado?",
    a: "Para aumentar as chances de aprovação, mantenha suas informações completas e atualizadas no cadastro. Também é importante possuir canais de divulgação ativos e respeitar as diretrizes da plataforma.",
  },
  {
    q: "Qualquer pessoa pode ser um Parceiro Promo?",
    a: "Sim. Criadores de conteúdo, influenciadores, blogueiros, agências, empresas e profissionais que atuam com audiência ou divulgação digital podem participar do programa, desde que atendam aos critérios de aprovação da plataforma.",
  },
  {
    q: "O Parceiros Promo é um programa de afiliados confiável?",
    a: "Sim. O Parceiros Promo pertence ao Grupo Amo Promo, que há mais de 20 anos desenvolve soluções e tecnologias para o setor de turismo. Entre as empresas do grupo estão o Seguros Promo, um dos maiores comparadores de seguro viagem do Brasil, e o Vai de Promo, plataforma especializada na comparação de passagens aéreas nacionais e internacionais. O Parceiros Promo reúne toda essa experiência em uma plataforma segura, transparente e focada em gerar resultados para seus afiliados.",
  },
];

const FaqV2: React.FC = () => {
  const [aberta, setAberta] = useState<number | null>(0);

  return (
    <section id="faq" className={styles.faq}>
      <h2>
        Perguntas Frequentes sobre o <span>Parceiros Promo</span>
      </h2>

      <div className={styles.list}>
        {FAQ.map((item, i) => {
          const open = aberta === i;
          return (
            <div
              key={item.q}
              className={`${styles.item} ${open ? styles.itemOpen : ""}`}
            >
              <button
                type="button"
                className={styles.question}
                onClick={() => setAberta(open ? null : i)}
                aria-expanded={open}
              >
                <h3>{item.q}</h3>
                {open ? <MinusIcon /> : <PlusIcon />}
              </button>
              <div
                className={`${styles.answerWrap} ${open ? styles.answerOpen : ""}`}
              >
                <p className={styles.answer}>{item.a}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FaqV2;
